import React, { useContext } from "react"
import LocaleContext from "../../../../../context/LocaleContext"
import CalculatorsInfoSectionDescriptionStyle from "./CalculatorsInfoSectionDescriptionStyle.module.styl"
import translate, { keys } from "../../../../../translation/translator"
const CalculatorsInfoSectionDescription = () => {
  const locale = useContext(LocaleContext).locale
  return (
    <div className={CalculatorsInfoSectionDescriptionStyle.holder}>
      <h2 className={CalculatorsInfoSectionDescriptionStyle.title}>
        {translate(keys.INDEX_CALC_INFO_FOUR_FREE, locale)}
        <span> {translate(keys.INDEX_CALC_INFO_FREE, locale)} </span>
        {translate(keys.INDEX_CALC_TOOLS_FOR_HELP, locale)}
      </h2>
      <h3 className={CalculatorsInfoSectionDescriptionStyle.description}>
        {translate(keys.INDEX_CALC_TOOLS_DESC, locale)}{" "}
      </h3>
    </div>
  )
}

export default CalculatorsInfoSectionDescription
